import axios from "axios";
import { isMasterView, getSelectedTenant, getActiveStore } from "@/lib/scope";
import { renewOfflineSessionToken } from '@/lib/offline-session';

const API = process.env.REACT_APP_API_BASE_URL || `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api/v1`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshInFlight = null;
const authRoute = url => /^\/?auth\/(login|refresh|logout)(\?|$)/.test(url || '');

api.interceptors.response.use(response => response, async error => {
  const original = error.config;
  if (error.response?.status !== 401 || !original || original._posRetried || authRoute(original.url) || !localStorage.getItem('pos_token')) {
    return Promise.reject(error);
  }
  original._posRetried = true;
  try {
    if (!refreshInFlight) {
      refreshInFlight = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true, headers: { 'X-POS-Refresh': '1' } })
        .finally(() => { refreshInFlight = null; });
    }
    const { data } = await refreshInFlight;
    localStorage.setItem('pos_token', data.access_token);
    renewOfflineSessionToken(data.access_token);
    original.headers = original.headers || {};
    original.headers.Authorization = `Bearer ${data.access_token}`;
    return api(original);
  } catch (refreshError) {
    if ([401, 403].includes(refreshError.response?.status)) window.dispatchEvent(new Event('pos-auth-expired'));
    return Promise.reject(error);
  }
});

api.interceptors.request.use((config) => {
  const appearanceControl = (config.method === "put" && config.url === "/appearance") || (config.method === "post" && /^\/appearance\/assets\/(logo|favicon)$/.test(config.url));
  const masterControl = config.method === "post" && (config.url?.startsWith("/master/platform/") || ["/master/tenants", "/master/backup/save", "/master/backup/probe", "/master/backup/test", "/master/backup/run", "/master/product-copy/preview", "/master/product-copy/apply"].includes(config.url));
  const readOnlyWorkbook = config.method === 'post' && config.url === '/documents/workbook';
  if (isMasterView() && !["get", "head", "options"].includes(config.method || "get") && config.url !== "/auth/login" && !masterControl && !appearanceControl && !readOnlyWorkbook) {
    return Promise.reject(new Error("Master hanya dapat melihat data tenant"));
  }
  const token = localStorage.getItem("pos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const tenant = getSelectedTenant();
  if (tenant) config.headers["X-Tenant-Id"] = tenant;
  const store = getActiveStore();
  if (store && !config.headers["X-Store-Id"]) config.headers["X-Store-Id"] = store;
  return config;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Terjadi kesalahan";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d?.msg ? d.msg : JSON.stringify(d))).join(", ");
  return String(detail);
}
